<template>
    <div class="relative" @click="$emit('click')">
        <input
            :type="type"
            :name="name"
            :class="applyStyles"
            :placeholder="placeholder"
            :value="value"
            @input="emitValue"
            :disabled="disabled"
            :required="required"
        />
        <div class="absolute inset-y-0 pr-6 right-0 flex items-center">
            <slot name="append"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'biller-input',
    props: {
        type: {
            type: String,
            default: 'text',
            validator: (val) => ['text', 'number', 'email', 'password'].indexOf(val) !== -1,
        },
        name: {
            type: String,
        },
        inputClasses: {
            type: String,
        },
        value: {
            type: String,
        },
        placeholder: {
            type: String,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        largeValue: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
    },
    model: {
        prop: 'value',
        event: 'input',
    },
    computed: {
        applyStyles: function() {
            return `h-16 px-4 placeholder-smoke-dark text-sm rounded-md  w-full bg-snow-300 ${this.inputClasses} ${
                this.largeValue ? 'large-value' : ''
            }`
        },
    },
    data() {
        return {
            inputVal: '',
        }
    },
    methods: {
        emitValue(e) {
            this.inputVal = e.target.value
            this.$emit('input', e.target.value)
            this.$emit('nativeInput', e)
            this.$forceUpdate()
        },
    },
}
</script>

<style lang="scss">
.large-value::placeholder {
    font-size: 14px !important;
    font-weight: normal !important;
    color: theme('colors.smoke.dark');
}

.large-value {
    font-size: 22px;
    font-weight: 600;
    color: theme('colors.purple.dark');
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type='number'] {
    -moz-appearance: textfield;
}
</style>
